import { render, staticRenderFns } from "./AnimOverlay.vue?vue&type=template&id=351ea5bf&"
import script from "./AnimOverlay.vue?vue&type=script&lang=js&"
export * from "./AnimOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports